export const formatLocalDateTime = (input: string | number | Date, options?: Intl.DateTimeFormatOptions) => {
  const createDateAssumingUTC = (value: string | number | Date): Date => {
    if (value instanceof Date) {
      return new Date(value.getTime());
    }
    if (typeof value === 'number') {
      // Treat as UNIX epoch milliseconds (already UTC)
      return new Date(value);
    }

    const raw = String(value).trim();

    // Numeric string? treat as epoch milliseconds
    if (/^\d+$/.test(raw)) {
      const ms = Number(raw);
      return new Date(ms);
    }

    // If string already specifies a timezone (Z or ±HH:MM), use as-is
    if (/[zZ]$/.test(raw) || /[-+]\d{2}:\d{2}$/.test(raw)) {
      return new Date(raw);
    }

    // Otherwise, interpret as UTC by appending Z
    const hasT = raw.includes('T');
    const normalized = (hasT ? raw : raw.replace(' ', 'T')) + 'Z';
    const dt = new Date(normalized);
    if (!isNaN(dt.getTime())) return dt;

    // Fallback: last resort native parsing
    return new Date(value);
  };

  const date = createDateAssumingUTC(input);

  // Always format in the viewer's local timezone
  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    ...(options || {}),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  return formatter.format(date);
};

export const formatLocalDate = (input: string | number | Date, options?: Intl.DateTimeFormatOptions) => {
  const date = input instanceof Date ? input : new Date(input);
  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...options,
  });
  return formatter.format(date);
};


